/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGeneticsReportRequestDto
 */
export interface UpdateGeneticsReportRequestDto {
    /**
     * New document name (max 255 characters, ASCII printable characters)
     * @type {string}
     * @memberof UpdateGeneticsReportRequestDto
     */
    documentName?: string;
    /**
     * File URL in storage
     * @type {string}
     * @memberof UpdateGeneticsReportRequestDto
     */
    fileUrl?: string;
}

/**
 * Check if a given object implements the UpdateGeneticsReportRequestDto interface.
 */
export function instanceOfUpdateGeneticsReportRequestDto(value: object): value is UpdateGeneticsReportRequestDto {
    return true;
}

export function UpdateGeneticsReportRequestDtoFromJSON(json: any): UpdateGeneticsReportRequestDto {
    return UpdateGeneticsReportRequestDtoFromJSONTyped(json, false);
}

export function UpdateGeneticsReportRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGeneticsReportRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'documentName': json['documentName'] == null ? undefined : json['documentName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
    };
}

export function UpdateGeneticsReportRequestDtoToJSON(json: any): UpdateGeneticsReportRequestDto {
    return UpdateGeneticsReportRequestDtoToJSONTyped(json, false);
}

export function UpdateGeneticsReportRequestDtoToJSONTyped(value?: UpdateGeneticsReportRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentName': value['documentName'],
        'fileUrl': value['fileUrl'],
    };
}

